export interface Lesson extends LearningUnit {
  contentMetaData: ContentMetaData;
  filters: Array<string>;
  uniqueKey: string;
  like: 0 | 5;
  likeCount: number;
  textTrack: string;
  saved?: boolean;
  knowledgeLevel?: string;
}

export interface ContentMetaData {
  id: string;
}

export interface LearningUnit {
  id: string;
  title: string;
  description: string;
  duration: number;
  locale: string;
  createdDate: Date;
  imageUrl: string;
  progress?: number;
  completion?: Date;
  timeRemaining?: number;
}

export interface Courses {
  courses: Array<Course>;
  listSize: number;
}

export interface Course extends LearningUnit {
  numberOfLessons: number;
}

export interface Lessons {
  lessons: Array<Lesson>;
  listSize: number;
}

export interface CourseLesson extends Lesson {
  lessonNumber?: number;
}

export interface SuperCourse extends Course {
  score: number;
  selectedCourse: boolean;
}

export interface SuperCourses {
  courses: Array<SuperCourse>;
  areQuestionsAnswered: boolean;
  listSize: number;
}

export enum FeatureContentType {
  LEARNING_PATH = 'LEARNING_PATH',
  COURSE = 'COURSE',
  LESSON = 'LESSON',
  WEBINAR = 'WEBINAR',
  MASTER_CLASS = 'MASTER_CLASS',
  EXTERNAL = 'EXTERNAL'
}

export interface FeatureContentData {
  fea: Array<FeatureContent>;
}

export interface FeatureContent extends LearningUnit {
  type: FeatureContentType;
  sequence: number;
  name: string;
  externalUrl?: string;
}

export interface FeatureContentLink {
  id: string;
  superCourse?: boolean;
}
